import { create } from 'zustand';
import { IDataPermissionCurrentUser, IGroupPermission } from '../pages/System/Permission/data';

interface PermissionState {
  detailPermission: IGroupPermission;
  setDetailPermission: (_detailPermission: IGroupPermission) => void;

  permissionCurrentUser: IDataPermissionCurrentUser;
  setPermissionCurrentUser: (_permissionCurrentUser: IDataPermissionCurrentUser) => void;
  isPermissionLoading: boolean;
  setPermissionLoading: (loading: boolean) => void;
}

const useStorePermission = create<PermissionState>((set) => ({
  detailPermission: {} as IGroupPermission,
  setDetailPermission: (_detailPermission) => set({ detailPermission: _detailPermission }),

  permissionCurrentUser: {} as IDataPermissionCurrentUser,
  setPermissionCurrentUser: (_permissionCurrentUser) =>
    set({ permissionCurrentUser: _permissionCurrentUser }),
  isPermissionLoading: true,
  setPermissionLoading: (loading) => set({ isPermissionLoading: loading }),
}));

export default useStorePermission;
